import React, { useEffect, useRef, useState } from "react";
import { BtnHeader } from "./Delivery";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  type Crop,
  type PixelCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { getCroppedImageSrc } from "../../utils/getCroppedImageSrc";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import Modals from "../Modals/Modals";
const ASPECT = 5 / 5;

const Thumbnail = ({ ...props }) => {
  const { navigate, thumbnailSrc, makeBookState, back } = props;
  let [imgSrc, setImgSrc] = useState(``);
  let thumbnailRef = useRef<any>(null);
  const [crop, setCrop] = useState<Crop>(); // 퍼센트/픽셀 아무거나 가능
  const [completed, setCompleted] = useState<PixelCrop>(); // 픽셀 단위 확정 크롭
  const [croppedSrc, setCroppedSrc] = useState<string>("");
  const imgRef = useRef<HTMLImageElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const prevUrlRef = useRef<string>(null);
  const [show, setShow] = useState(false);

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = e.currentTarget;
    const initial = makeAspectCrop(
      { unit: "%", width: 90 }, // 화면의 90% 폭으로 시작
      ASPECT,
      naturalWidth,
      naturalHeight
    );
    setCrop(centerCrop(initial, naturalWidth, naturalHeight));
  };

  const makeSrc = async () => {
    if (!imgRef.current || !completed) return;
    // Blob URL 생성 (권장). dataURL 원하면 asDataURL: true
    const url = await getCroppedImageSrc(imgRef.current, completed, {
      type: "image/jpeg",
      quality: 0.9,
      asDataURL: false,
    });

    // 이전 Blob URL 정리
    if (prevUrlRef.current) URL.revokeObjectURL(prevUrlRef.current);
    prevUrlRef.current = url;
    setCroppedSrc(url);
    return url;
  };

  // 캔버스에 크롭 미리보기 그리기 (고해상도 대응)
  useEffect(() => {
    if (!completed || !imgRef.current || !canvasRef.current) return;
    const image = imgRef.current;
    const canvas = canvasRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const dpr = window.devicePixelRatio || 1;
    canvas.width = Math.floor(completed.width * dpr);
    canvas.height = Math.floor(completed.height * dpr);

    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.scale(dpr, dpr);
    ctx.imageSmoothingQuality = "high";
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(
      image,
      completed.x * scaleX,
      completed.y * scaleY,
      completed.width * scaleX,
      completed.height * scaleY,
      0,
      0,
      completed.width,
      completed.height
    );
  }, [completed]);

  // 1. 썸네일에 사용할 이미지 첨부
  const handleUpload = async (ev: React.ChangeEvent<HTMLInputElement>) => {
    if (ev.target.files && ev.target.files.length > 0) {
      let reader = new FileReader();
      reader.addEventListener(`load`, () => {
        setImgSrc(reader.result?.toString() || ``);
      });
      reader.readAsDataURL(ev.target.files[0]);
    }
  };

  // 2. 썸네일 이미지 최종 크롭
  const onSelectSrc = async () => {
    if (imgSrc === ``) {
      return setShow(true);
      // alert(`이미지를 등록해주세요.`);
    }
    let blobImg: any = await makeSrc();
    thumbnailSrc(blobImg);
    // 1. 썸네일용 이미지 src 생성
  };

  // 간단한 파일 업로드 처리
  const handleFileUpload = () => {
    if (thumbnailRef?.current) {
      thumbnailRef.current.click();
    }
  };

  return (
    <>
      <div className={`section_wrap sec_wrap_3`}>
        <BtnHeader
          makeBookState={makeBookState}
          back={() => back()}
          navigate={navigate}
        />
        <div className={`sec sec_1 text-center`}>
          <h3 className={`h1`}>표지에 들어갈 이미지를 업로드해주세요.</h3>
        </div>
        <div className={`sec sec_2`}>
          <div className={`img_box`}>
            <ReactCrop
              crop={crop}
              onChange={(c, percent) => setCrop(percent)} // 퍼센트 단위로 보관 권장
              onComplete={(pxCrop) => setCompleted(pxCrop)} // 픽셀 크롭은 캔버스에 사용
              aspect={ASPECT}
              ruleOfThirds
            >
              <img
                ref={imgRef}
                src={imgSrc}
                onLoad={onImageLoad}
                // 외부 도메인 이미지를 자를 땐 CORS 허용 + crossOrigin 설정 필수
                crossOrigin="anonymous"
                alt=""
              />
            </ReactCrop>

            <div className={`hidden`}>
              <canvas
                ref={canvasRef}
                style={{ maxWidth: 400, border: "1px solid #ddd" }}
              />
            </div>
            <input
              type="file"
              className="hidden"
              name="thumbnail"
              ref={thumbnailRef}
              accept="image/*"
              multiple={false}
              onChange={handleUpload}
            />
            <button className="btn btn-primary" onClick={handleFileUpload}>
              사진 업로드
            </button>
          </div>
        </div>
        <div className={`footer_btn`} onClick={onSelectSrc}>
          <button className={`btn btn-primary block w-[100%] rounded-none`}>
            다음
          </button>
        </div>
      </div>
      <Modals
        show={show}
        alertType={`default`}
        onClose={(res: any) => setShow(res)}
      >
        이미지를 등록해주세요.
      </Modals>
    </>
  );
};

export default Thumbnail;
